const SALES_EXP_ACADEMY_PAGE_FLAG = "sales-exp-academy-page";

export { SALES_EXP_ACADEMY_PAGE_FLAG };
